import React from 'react'
import { COLORES } from '../../../config/colores'

export const COLUMNAS_MONITOR_BUQUE = [
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'aCargar',
    label: 'A cargar',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (kilos) => {
        return kilos.toLocaleString('es-ES')
      }
    }
  },
  {
    name: '',
    label: '',
    options: {
      filter: false,
      sort: false
    }
  }
]

export const COLUMNAS_MONITOR_EXPORTADOR = [
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem',
          position: 'sticky',
          left: 0,
          zIndex: 101
        }
      }),
      setCellProps: () => ({
        style: {
          background: 'white',
          zIndex: 100,
          position: 'sticky',
          left: 0
        }
      })
    }
  },
  {
    name: 'razonSocial',
    label: 'Exportador',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      setCellProps: () => ({
        style: {
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      })
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'nombrePais',
    label: 'Pais destino',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      })
    }
  },
  {
    name: 'aCargar',
    label: 'A cargar',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (aCargar) => {
        return (<>{aCargar.toLocaleString('es-ES')} kg.</>)
      }
    }
  },
  {
    name: 'cargado',
    label: 'Cargado',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (cargado) => {
        return (<><b>{cargado.toLocaleString('es-ES')}</b> kg.</>)
      }
    }
  },
  {
    name: 'restante',
    label: 'Restante',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (cargado) => {
        return (<><b>{cargado.toLocaleString('es-ES')}</b> kg.</>)
      }
    }
  }
]

export const COLUMNAS_POR_BODEGA_DESTINO = [
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem',
          position: 'sticky',
          left: 0,
          zIndex: 101
        }
      }),
      setCellProps: () => ({
        style: {
          background: 'white',
          zIndex: 100,
          position: 'sticky',
          left: 0
        }
      })
    }
  },
  {
    name: 'bodega',
    label: 'Bodega',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      setCellProps: () => ({
        style: {
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      })
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Cereal variedad',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (variedad) => {
        return (variedad.trim() !== 'UNDEF') ? variedad : ' - '
      }
    }
  },
  {
    name: 'nombrePais',
    label: 'Pais destino',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      })
    }
  },
  {
    name: 'aCargar',
    label: 'A cargar',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (aCargar) => {
        return (<>{aCargar.toLocaleString('es-ES')} kg.</>)
      }
    }

  },
  {
    name: 'cargado',
    label: 'Cargado',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (cargado) => {
        return (<><b>{cargado.toLocaleString('es-ES')}</b> kg.</>)
      }
    }
  },
  {
    name: 'restante',
    label: 'Restante',
    options: {
      filter: false,
      sort: false,
      setCellHeaderProps: () => ({
        style: {
          background: COLORES.blue.primaryDark,
          color: 'white',
          fontSize: '1rem'
        }
      }),
      customBodyRender: (restante) => {
        return (<><b>{restante.toLocaleString('es-ES')}</b> kg.</>)
      }
    }
  }
]
